<template>
    <div>

      <div class="data-header">
        <div class="header-left">
          <!--<div>下拉</div>-->
          <div class="header-left-item">当前景区人流量在阈值内</div>
          <!--<div>下拉</div>-->
        </div>
        <div class="data-title">篁岭旅游大数据平台</div>
        <div class="header-time">{{current_time}}</div>
      </div>
      <!--头部第一屏的图表-->
      <div class="top-data">
        <div class="top-data-item">
          <div class="top-item-t">今日入园人数</div>
          <div class="top-item-c">{{topData.in_park_num|numberToCurrency}}<span class="unit">人</span></div>
          ﻿<div class="top-item-b">
              <div class="tb-rate">
                周同比
                  <img v-if="topData.last_week_in_park_num>0" style="width: 10px; height: 12px;" src="../../static/img/data_up_arrow.png">
                <img v-else style="width: 10px; height: 12px;" src="../../static/img/data_down_arrow.png">
                {{topData.last_week_in_park_num|numberToString}}%
              </div>
               <div class="pk-week flex">
                 日同比
                 <img v-if="topData.yesterday_in_park_num>0" style="width: 10px; height: 12px;" src="../../static/img/data_up_arrow.png">
                 <img v-else style="width: 10px; height: 12px;" src="../../static/img/data_down_arrow.png">
                 {{topData.yesterday_in_park_num|numberToString}}%
              </div>

          </div>
        </div>

        <div class="top-data-item">
          <div class="top-item-t">今日售票数量</div>
          <div class="top-item-c">{{topData.today_ticket_number|numberToCurrency}}<span class="unit">张</span></div>
          ﻿<div class="top-item-b">
          <div class="tb-rate">
            周同比
            <img v-if="topData.last_week_ticket_num>0" style="width: 10px; height: 12px;" src="../../static/img/data_up_arrow.png">
            <img v-else style="width: 10px; height: 12px;" src="../../static/img/data_down_arrow.png">
            {{topData.last_week_ticket_num|numberToString}}%
          </div>
          <div class="pk-week flex">
            日同比
            <img v-if="topData.yesterday_ticket_num>0" style="width: 10px; height: 12px;" src="../../static/img/data_up_arrow.png">
            <img v-else style="width: 10px; height: 12px;" src="../../static/img/data_down_arrow.png">
            {{topData.yesterday_ticket_num|numberToString}}%
          </div>

        </div>
        </div>

        <div class="top-data-item">
          <div class="top-item-t">今日总营业额</div>
          <div class="top-item-c">{{topData.today_ticket_turnover|numberToCurrency}}<span class="unit">元</span></div>
          ﻿<div class="top-item-b">
          <div class="tb-rate">
            周同比
            <img v-if="topData.last_week_ticket_turnover_num>0" style="width: 10px; height: 12px;" src="../../static/img/data_up_arrow.png">
            <img v-else style="width: 10px; height: 12px;" src="../../static/img/data_down_arrow.png">
            {{topData.last_week_ticket_turnover_num|numberToString}}%
          </div>
          <div class="pk-week flex">
            日同比
            <img v-if="topData.yesterday_ticket_turnover_num>0" style="width: 10px; height: 12px;" src="../../static/img/data_up_arrow.png">
            <img v-else style="width: 10px; height: 12px;" src="../../static/img/data_down_arrow.png">
            {{topData.yesterday_ticket_turnover_num|numberToString}}%
          </div>

        </div>
        </div>

        <div class="top-data-item">
          <div class="top-item-t">售票交易额</div>
          <div class="top-item-c">{{topData.ticket_transaction_volume|numberToCurrency}}<span class="unit">元</span></div>
          ﻿<div class="top-item-b">
          <div class="tb-rate">
            售票笔数{{topData.ticket_transaction_num|numberToCurrency}}笔
          </div>


        </div>
        </div>

        <div class="top-data-item">
          <div class="top-item-t">电商交易额</div>
          <div class="top-item-c">{{topData.shop_order_num?topData.shop_order_num:0|numberToCurrency}}<span class="unit">元</span></div>
          ﻿<div class="top-item-b">
          <div class="tb-rate">
            售票笔数{{topData.shop_order_volume?topData.shop_order_volume:0|numberToCurrency}}笔
          </div>

        </div>
        </div>

        <div class="top-data-item">
          <div class="top-item-t">景区内交易额</div>
          <div class="top-item-c">{{topData.scenic_spot_volume|numberToCurrency}}<span class="unit">元</span></div>
          ﻿<div class="top-item-b">
          <div class="tb-rate">
            销售笔数{{topData.scenic_spot_num|numberToCurrency}}<span>元</span>
          </div>

        </div>
        </div>


      </div>

      <!--中部的图表-->
      <div class="center-data">
        <!--这里左边有两个图表-->
        <div class="center-l">
          <div class="people-rate-list">
            <div class="people-rate-top">
              <div>
                <div class="tit">在园人数</div>
                <div class="num">{{leftData.current_traffic}}<span>人</span></div>
              </div>
              <div class="line">
                <div class="tit">景区拥挤程度</div>
                <div class="num">{{leftData.crowding*100}}<span>%</span></div>
              </div>

            </div>
            <div class="people-rate-title">
              <div class="table-item" style="background: #181E22!important;">
                <div class="item-scenic">景点</div>
                <div class="item-num">人数</div>
              </div>
            </div>
            <div class="people-rate-bottom">
              <div class="table-item" v-for="(item, index) in scenic_people_num_list" :key="index">
                <div class="item-scenic">{{item.name}}</div>
                <div class="item-num">{{item.num}}</div>
              </div>

            </div>
          </div>
        </div>


        <!--这里中间有两个图表 一个热力图 一个车流图-->
        <div class="center-c">
          <div class="hot-map">
            <div class="map-title">
              <div class="left-line"></div><div>景区内人流热力图</div>
            </div>
            <div id="main" class="hot-map-data"></div>
          </div>
            <!--<div class="hot-map">-->
                <!--<div class="map-title">-->
                    <!--<div class="left-line"></div><div>景区客流来源图</div>-->
                <!--</div>-->
                <!--<div id="fly_main" class="hot-map-data"></div>-->
            <!--</div>-->
        </div>


        <div class="center-r">
          <div class="people-data">
            <div class="people-title">
              <div class="left-line"></div><div>今日入园游客分析</div>
            </div>
            <div class="people-content">
                <div class="people-content-title">游客性别占比</div>
              <div class="people-content-item">
                <div id="user_male_form" style="height:140px"  class="ticket_reservation"></div>
              </div>

                <div class="people-content-title people-content-title2">游客年龄占比</div>
                <div class="people-content-item">
                    <div id="user_age_form" style="height:140px"  class="ticket_reservation"></div>
                </div>

                <div class="people-content-title people-content-title2">游客来源占比</div>
                <div class="people-content-item">
                    <div id="user_from_form" style="height:140px"  class="ticket_reservation"></div>
                </div>

            </div>
          </div>
        </div>
      </div>



      <div  class="echart_box flex flex_s_b">



      </div>
      <!--入园人数汇总等第二屏图表-->
      <div class="echart_box echart_box1 flex flex_s_b">
        <!--入园人数汇总-->

        <!--右边-->

      </div>
    </div>
</template>

<script>
  import { hlLeftData, hlTopData, txHeatMapApi, getUsrPortraitApi} from '../api/SceneTourists'

  //各地省份的经纬度
  var geoCoordMap = {
    "海门":[121.15,31.89],
    "鄂尔多斯":[109.781327,39.608266],
    "招远":[120.38,37.35],
    "舟山":[122.207216,29.985295],
    "齐齐哈尔":[123.97,47.33],
    "盐城":[120.13,33.38],
    "赤峰":[118.87,42.28],
    "青岛":[120.33,36.07],
    "乳山":[121.52,36.89],
    "金昌":[102.188043,38.520089],
    "泉州":[118.58,24.93],
    "莱西":[120.53,36.86],
    "日照":[119.46,35.42],
    "胶南":[119.97,35.88],
    "南通":[121.05,32.08],
    "拉萨":[91.11,29.97],
    "云浮":[112.02,22.93],
    "梅州":[116.1,24.55],
    "文登":[122.05,37.2],
    "上海":[121.48,31.22],
    "攀枝花":[101.718637,26.582347],
    "威海":[122.1,37.5],
    "承德":[117.93,40.97],
    "厦门":[118.1,24.46],
    "汕尾":[115.375279,22.786211],
    "潮州":[116.63,23.68],
    "丹东":[124.37,40.13],
    "太仓":[121.1,31.45],
    "曲靖":[103.79,25.51],
    "烟台":[121.39,37.52],
    "福州":[119.3,26.08],
    "瓦房店":[121.979603,39.627114],
    "即墨":[120.45,36.38],
    "抚顺":[123.97,41.97],
    "玉溪":[102.52,24.35],
    "张家口":[114.87,40.82],
    "阳泉":[113.57,37.85],
    "莱州":[119.942327,37.177017],
    "湖州":[120.1,30.86],
    "汕头":[116.69,23.39],
    "昆山":[120.95,31.39],
    "宁波":[121.56,29.86],
    "湛江":[110.359377,21.270708],
    "揭阳":[116.35,23.55],
    "荣成":[122.41,37.16],
    "连云港":[119.16,34.59],
    "葫芦岛":[120.836932,40.711052],
    "常熟":[120.74,31.64],
    "东莞":[113.75,23.04],
    "河源":[114.68,23.73],
    "淮安":[119.15,33.5],
    "泰州":[119.9,32.49],
    "南宁":[108.33,22.84],
    "营口":[122.18,40.65],
    "惠州":[114.4,23.09],
    "江阴":[120.26,31.91],
    "蓬莱":[120.75,37.8],
    "韶关":[113.62,24.84],
    "嘉峪关":[98.289152,39.77313],
    "广州":[113.23,23.16],
    "延安":[109.47,36.6],
    "太原":[112.53,37.87],
    "清远":[113.01,23.7],
    "中山":[113.38,22.52],
    "昆明":[102.73,25.04],
    "寿光":[118.73,36.86],
    "盘锦":[122.070714,41.119997],
    "长治":[113.08,36.18],
    "深圳":[114.07,22.62],
    "珠海":[113.52,22.3],
    "宿迁":[118.3,33.96],
    "咸阳":[108.72,34.36],
    "铜川":[109.11,35.09],
    "平度":[119.97,36.77],
    "佛山":[113.11,23.05],
    "海口":[110.35,20.02],
    "江门":[113.06,22.61],
    "章丘":[117.53,36.72],
    "肇庆":[112.44,23.05],
    "大连":[121.62,38.92],
    "临汾":[111.5,36.08],
    "吴江":[120.63,31.16],
    "石嘴山":[106.39,39.04],
    "沈阳":[123.38,41.8],
    "苏州":[120.62,31.32],
    "茂名":[110.88,21.68],
    "嘉兴":[120.76,30.77],
    "长春":[125.35,43.88],
    "胶州":[120.03336,36.264622],
    "银川":[106.27,38.47],
    "张家港":[120.555821,31.875428],
    "三门峡":[111.19,34.76],
    "锦州":[121.15,41.13],
    "南昌":[115.89,28.68],
    "柳州":[109.4,24.33],
    "三亚":[109.511909,18.252847],
    "自贡":[104.778442,29.33903],
    "吉林":[126.57,43.87],
    "阳江":[111.95,21.85],
    "泸州":[105.39,28.91],
    "西宁":[101.74,36.56],
    "宜宾":[104.56,29.77],
    "呼和浩特":[111.65,40.82],
    "成都":[104.06,30.67],
    "大同":[113.3,40.12],
    "镇江":[119.44,32.2],
    "桂林":[110.28,25.29],
    "张家界":[110.479191,29.117096],
    "宜兴":[119.82,31.36],
    "北海":[109.12,21.49],
    "西安":[108.95,34.27],
    "金坛":[119.56,31.74],
    "东营":[118.49,37.46],
    "牡丹江":[129.58,44.6],
    "遵义":[106.9,27.7],
    "绍兴":[120.58,30.01],
    "扬州":[119.42,32.39],
    "常州":[119.95,31.79],
    "潍坊":[119.1,36.62],
    "重庆":[106.54,29.59],
    "台州":[121.420757,28.656386],
    "南京":[118.78,32.04],
    "滨州":[118.03,37.36],
    "贵阳":[106.71,26.57],
    "无锡":[120.29,31.59],
    "本溪":[123.73,41.3],
    "克拉玛依":[84.77,45.59],
    "渭南":[109.5,34.52],
    "马鞍山":[118.48,31.56],
    "宝鸡":[107.15,34.38],
    "焦作":[113.21,35.24],
    "句容":[119.16,31.95],
    "北京":[116.46,39.92],
    "徐州":[117.2,34.26],
    "衡水":[115.72,37.72],
    "包头":[110,40.58],
    "绵阳":[104.73,31.48],
    "乌鲁木齐":[87.68,43.77],
    "枣庄":[117.57,34.86],
    "杭州":[120.19,30.26],
    "淄博":[118.05,36.78],
    "鞍山":[122.85,41.12],
    "溧阳":[119.48,31.43],
    "库尔勒":[86.06,41.68],
    "安阳":[114.35,36.1],
    "开封":[114.35,34.79],
    "济南":[117,36.65],
    "德阳":[104.37,31.13],
    "温州":[120.65,28.01],
    "九江":[115.97,29.71],
    "邯郸":[114.47,36.6],
    "临安":[119.72,30.23],
    "兰州":[103.73,36.03],
    "沧州":[116.83,38.33],
    "临沂":[118.35,35.05],
    "南充":[106.110698,30.837793],
    "天津":[117.2,39.13],
    "富阳":[119.95,30.07],
    "泰安":[117.13,36.18],
    "诸暨":[120.23,29.71],
    "郑州":[113.65,34.76],
    "哈尔滨":[126.63,45.75],
    "聊城":[115.97,36.45],
    "芜湖":[118.38,31.33],
    "唐山":[118.02,39.63],
    "平顶山":[113.29,33.75],
    "邢台":[114.48,37.05],
    "德州":[116.29,37.45],
    "济宁":[116.59,35.38],
    "荆州":[112.239741,30.335165],
    "宜昌":[111.3,30.7],
    "义乌":[120.06,29.32],
    "丽水":[119.92,28.45],
    "洛阳":[112.44,34.7],
    "秦皇岛":[119.57,39.95],
    "株洲":[113.16,27.83],
    "石家庄":[114.48,38.03],
    "莱芜":[117.67,36.19],
    "常德":[111.69,29.05],
    "保定":[115.48,38.85],
    "湘潭":[112.91,27.87],
    "金华":[119.64,29.12],
    "岳阳":[113.09,29.37],
    "长沙":[113,28.21],
    "衢州":[118.88,28.97],
    "廊坊":[116.7,39.53],
    "菏泽":[115.480656,35.23375],
    "合肥":[117.27,31.86],
    "武汉":[114.31,30.52],
    "大庆":[125.03,46.58]
  };
  var map = null;
  // 创建热力图对象
  var heat = null;
  export default {
    filters: {
      numberToString(num){
        // num转成字符串先

        var num_data = parseFloat(num).toFixed(2)
        if (num_data < 0) {
          num_data = -100 * num_data
        } else {
          num_data = 100 * num_data
        }
        num_data = num_data.toFixed(2).toString()
        return num_data
      },
      numberToCurrency(num){
        var num_str = num.toString()
        var num_arr = num_str.split('.')
        var int_str = ''
        var float_str = ''
        if (num_arr.length > 1) {
          float_str = num_arr[1]
        }
        int_str = num_arr[0]
        int_str = int_str.split("").reverse().join("") // 翻转整数
        var temp = ""; // 临时变量
        for(var i = 0; i < int_str.length; i++) {
          temp += int_str[i];
          if((i + 1) % 3 == 0 && i != int_str.length -1) {
            temp += ",";// 每隔三个数字拼接一个逗号
          }
        }
        temp = temp.split("").reverse().join("");// 加完逗号之后翻转
        if (float_str.length > 0) {
          if (float_str.length > 2) {
            float_str = float_str[0] + float_str[1]
          }
          temp += '.' + float_str  // 加回浮点数部分
        }
        return temp
      }
    },
    data() {
      return {
        geoCoordMap:{}, //  全国省份。  也不能叫全省吧。 就是所有数据要展示的经纬度。
        SSData: [],   // 具体展示的数据。
        animationDuration: 3000,
        dataFive: [],
        current_time: '',  // 当前时间
        topData: {
          "in_park_num": 0,
          "last_week_in_park_num": 0,
          "yesterday_in_park_num": 0,
          "today_ticket_number": 0,
          "last_week_ticket_number": 0,
          "yesterday_ticket_number": 0,
          "today_ticket_turnover": 0,
          "last_week_ticket_turnover": 0,
          "yesterday_ticket_turnover": 0,
          "ticket_transaction_volume": 0,
          "ticket_transaction_num": 0,
          "scenic_spot_volume": 0,
          "scenic_spot_num": 0
        },
        leftData: {
          current_traffic: 0,
          crowding: 0
        },
        scenic_people_num_list: [
          { name: '滑道漂流', num: 0, present: 0.0614},
            { name: '冒险森林', num: 0, present: 0.0119},
            { name: '民俗文化展览馆', num: 0, present: 0.0409},
            { name: '花溪水街', num: 0, present: 0.2542},
            { name: '晒工坊', num: 0, present: 0.05631},
            { name: '五桂堂', num: 0, present: 0.01023},
            { name: '倒屋', num: 0, present: 0.02047},
            { name: '树和堂', num: 0, present: 0.04266},
            { name: '水口红豆杉林', num: 0, present: 0.0273},
            { name: '悬浮屋', num: 0, present: 0.0153},
            { name: '天街', num: 0, present: 0.45051},
            { name: '滑索', num: 0, present: 0.0085},
        ],
          tourists_gender: {}, // 性别占比
          tourists_age_range: {}, // 年龄占比
          user_from_data: [],  // 购票来源
          province_user_list_pie: [] // 来源
      };
    },
    methods: {
      get_top_data() {
        var _this = this
        hlTopData().then(res=>{
          _this.topData = res.data.data
        })
      },
      get_left_data() {
        var _this = this
        hlLeftData().then(res=>{
          _this.leftData = res.data.data
          _this.leftData.crowding = (_this.leftData.current_traffic / 10000).toFixed(2)
          _this.scenic_people_num_list.forEach(item=>{
              item.num = (item.present * _this.leftData.current_traffic).toFixed(0)
          })
            console.info('_this.scenic_people_num_list', _this.scenic_people_num_list)
        })
      },
      center_map() {
        txHeatMapApi().then(res=>{
          // 获取热力数据
          // 向热力图传入数据
          heat.setData(res.data.data.heat_map);
        })
      },
        get_user_portrait() {
          var _this = this
            getUsrPortraitApi({
                select_data_type: 2,
                date_filter_val: '2'
            }).then(res=>{
                _this.tourists_gender = res.data.data.tourists_gender
                _this.tourists_gender.series.forEach(item=>{
                    delete item.percent
                    item.value = item.data
                    delete item.data
                })
                _this.get_user_male()
                _this.tourists_age_range = res.data.data.tourists_age_range
                _this.tourists_age_range.series.forEach(item=>{
                    delete item.percent
                    item.value = item.data
                    delete item.data
                })
                _this.get_user_age()
                var customer_class_num_info = res.data.data.customer_class_num_info
                _this.user_from_data.push({name: 'OTA', value: customer_class_num_info.ota})
                _this.user_from_data.push({name: '团队', value: customer_class_num_info.agency})
                _this.user_from_data.push({name: '散客', value: customer_class_num_info.member})
                _this.user_from_data.push({name: '小程序', value: customer_class_num_info.wx})
                _this.get_user_from()
            })
        },
        get_user_origin() {
            var _this = this
            getUsrPortraitApi({
              select_data_type: 3,
              date_filter_val: '2'
            }).then(res=>{
                var province_user_list = res.data.data.province_user_list
                province_user_list.forEach(item=>{
                    if (item.province && item.province !== '') {
                        _this.province_user_list_pie.push({name: item.province, value: item.user_num})
                    }
                })

            })
        },
      get_user_male(){
        var user_male_form = this.echarts.init(document.getElementById('user_male_form'));
        user_male_form.setOption({
          animationDuration: this.animationDuration,
          tooltip: {
            trigger: 'item'
          },
          legend: {
            top: 'center',
            right: 0,
            type: 'scroll',
            orient: 'vertical',
            textStyle: {
              color: '#fff'
            }
          },
          series: [
            {
              center: ['30%', '50%'],
              color: ['#FF898A', '#6BB7FF', '#FFC06B'],
              name: '占比',
              type: 'pie',
              radius: ['40%', '70%'],
              avoidLabelOverlap: false,
              itemStyle: {
                borderRadius: 10
              },
              label: {
                show: false,
                position: 'center'
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: '14',
                  fontWeight: 'bold'
                }
              },
              labelLine: {
                show: false
              },
              data: this.tourists_gender.series
            }
          ]
        })

      },
    get_user_age(){
        var user_age_form = this.echarts.init(document.getElementById('user_age_form'));
        user_age_form.setOption({
            animationDuration: this.animationDuration,
            tooltip: {
                trigger: 'item'
            },
            legend: {
                top: 'center',
                right: 0,
                type: 'scroll',
                orient: 'vertical',
                textStyle: {
                    color: '#fff'
                }
            },
            series: [
                {
                    center: ['30%', '50%'],
                    color: ['#6BB7FF', '#986BFF', '#FF898A', '#FFC06B'],
                    name: '占比',
                    type: 'pie',
                    radius: ['40%', '70%'],
                    avoidLabelOverlap: false,
                    itemStyle: {
                        borderRadius: 10
                    },
                    label: {
                        show: false,
                        position: 'center'
                    },
                    emphasis: {
                        label: {
                            show: true,
                            fontSize: '14',
                            fontWeight: 'bold'
                        }
                    },
                    labelLine: {
                        show: false
                    },
                    data: this.tourists_age_range.series
                }
            ]
        })

    },
        get_user_from(){
            var user_from_form = this.echarts.init(document.getElementById('user_from_form'));
            user_from_form.setOption({
                animationDuration: this.animationDuration,
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    top: 'center',
                    right: 0,
                    type: 'scroll',
                    orient: 'vertical',
                    textStyle: {
                        color: '#fff'
                    }
                },
                series: [
                    {
                        center: ['30%', '50%'],
                        color: ['#6BB7FF', '#986BFF', '#FF898A', '#FFC06B'],
                        name: '占比',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        itemStyle: {
                            borderRadius: 10
                        },
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: '14',
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: this.user_from_data
                    }
                ]
            })

        },
        get_user_origin(){
            var fly_main = this.echarts.init(document.getElementById('fly_main'));
            fly_main.setOption({
                animationDuration: this.animationDuration,
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    top: 'center',
                    right: 0,
                    type: 'scroll',
                    orient: 'vertical',
                    textStyle: {
                        color: '#fff'
                    }
                },
                series: [
                    {
                        center: ['30%', '50%'],
                        color: ['#6BB7FF', '#986BFF', '#FF898A', '#FFC06B'],
                        name: '占比',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        itemStyle: {
                            borderRadius: 10
                        },
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: '14',
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: this.user_from_data
                    }
                ]
            })

        }
    },
    mounted() {
      var center = new TMap.LatLng(29.320494, 118.119699)
      map = new TMap.Map(document.getElementById("main"), {
        //是地图中心经纬度
        center: center,
        zoom:17,//范围
        mapStyleId: 'style1',
        pitch: 45
      });
      // 创建热力图对象
      heat = new TMap.visualization.Heat({
        max: 5, // 热力最强阈值
        min: 0, // 热力最弱阈值
        height: 40, // 峰值高度
        radius: 30 // 最大辐射半径
      }).addTo(map);
      var opacity = heat.getOpacity();
      heat.setOpacity(0.8); // 设置透明度变化范围
      var gradient = heat.getGradientColor(); // 获取渐变色
      gradient.stops[0.1] = "#fff";
      gradient.stops[0.2] = '#e7eaef'
      gradient.stops[0.3] = '#5589f2'
      gradient.stops[0.6] = '#E9AB1D'
      heat.setGradientColor(gradient); // 设置渐变色
      this.get_left_data()
      this.get_top_data()
      this.center_map() // 中间大地图
      this.get_user_portrait() //用户年龄 性别
      //this.get_user_origin() // 用户来源
      var _this = this
      this.timer1 = setInterval(function() {
        _this.get_left_data()
        _this.get_top_data()
      }, 30000)
      this.timer = setInterval(function() {
        var _date = new Date()
        _this.current_time = _date.toLocaleString() + ' 星期' + '日一二三四五六'.charAt(_date.getDay());
      }, 1000)
    },
    components: {

    }
  };
</script>

<style scoped>
  .bottom_right_box{
    width: 40vw;
  }
  .echart_box1{
    margin-top:0;
  }
  /*中间省份排名*/
  .province_ranking{
    position: absolute;
    z-index: 2;
    left: 2vw;
    top:2.5vw;
    font-size: 12px;
  }
  .province_ranking>li{
    margin-bottom:.5vw;
    color:#626465;
  }
  .data-header{
    height: 58px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
  .data-header .header-time{
    font-size: 24px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 24px;
      width: 23%;
  }
  .data-header .header-left{
    display: flex;
    flex-direction: row;
  }
  .header-left .header-left-item{
    width: 264px;
    height: 50px;
    background: #45ab3e;
    border-radius: 28px;
    opacity: 0.6;
    font-size: 18px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 50px;
    margin: 16px auto;
    text-align: center;
  }
  .top-data{
    display: flex;
    flex-direction: row;
  }
  .top-data .top-data-item{
    width: 15%;
    display: flex;
    flex-direction: column;
    background: #181E22;
    border-radius: 6px;
    padding: 19px 20px;
    margin: 0 0.83%;
  }
  .top-data-item .top-item-t{
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 14px;
  }
  .top-data-item .top-item-c{
    font-size: 32px;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 40px;
    margin: 14px 0;
  }
  .top-data-item .top-item-c .unit{
    font-size: 15px;
  }
  .top-data-item .top-item-b{
    display: flex;
    font-size: 14px;
    font-weight: 400;
    color: #138EFF;
    flex-direction: column;
    line-height: 14px;
    flex-wrap: nowrap;
    justify-content: space-between;
  }
  .top-item-b .tb-rate{
    display: -webkit-box;
  }

  /*中间的图表*/
  .center-data{
    display: flex;
    flex-direction: row;
    margin-top:20px;
  }
  .center-data .center-l{

    background: #181E22;
    border-radius: 6px;
    width: 15%;
    margin: 0 0.83%;
    height: 512px;
  }
  .center-l .people-rate-list{
    height: 512px;
  }
  .people-rate-list .people-rate-top{
    width: 100%;
    height: 90px;
    background: #171A1D;
    border-radius: 6px;
    padding:20px;
    display: flex;
    justify-content: space-between;
  }
  .people-rate-top .tit{
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 14px;
  }
  .people-rate-top .num{
    font-size: 20px;
    font-weight: 600;
    color: #138EFF;
    line-height: 20px;
    margin-top: 16px;
  }
  .people-rate-top .line{
    border-left: 1px solid #2A446B;
    padding-left: 20px;
  }
  .people-rate-title{
    display: flex;
    flex-direction: column;
    text-align: center;
    background: #171A1D;
  }
  .people-rate-bottom{
    display: flex;
    flex-direction: column;
    height: 378px;
    overflow: scroll;
  }
  .people-rate-list .table-item{
    height: 44px;
    justify-content: space-between;
    display: flex;
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 14px;
    padding: 12px 15px;
  }
  .people-rate-list .table-item:nth-child(2n-1){
    background: #1F262A;
  }
  .people-rate-list .table-item .item-scenic{
    display: flex;
  }
  .people-rate-list .table-item .item-num{
    display: flex;
  }

  .center-data .center-c{
    width: 65%;
    margin: 0 0.83%;
  }
  .center-c .hot-map{
    background: #171A1D;
    border-radius: 6px;
    height: 512px;
  }
  .center-c .hot-map .map-title{
    display: flex;
    height: 44px;
    padding: 14px 20px;
      font-size:16px;
  }
  .hot-map .map-title .left-line{
    width: 4px;
    background: #138EFF;
    margin-right: 20px;
  }
  .hot-map .hot-map-data{
    width: 100%;
    height:468px;
  }


  .center-data .center-r{
    width: 15%;
    margin: 0 0.83%;
    height: 716px;
  }
  .center-r .people-data{
    /*height: 716px;*/
    background: #181E22;
    border-radius: 6px;
  }
  .center-r .people-data .people-title{
    display: flex;
    height: 44px;
    padding: 14px 20px;
      font-size: 16px;
      background-color: #171819;
  }
  .people-data .left-line{
    width: 4px;
    background: #138EFF;
    margin-right: 20px;
  }
  .data-title{
    background: linear-gradient(to right, rgb(33, 199, 255), rgb(14, 255, 242));
    -webkit-background-clip: text;
    color: transparent;
    text-align: center;
    font-size: 50px;
    font-family: huxiaobonan;
    font-weight: 500;
  }
  .people-content{
      padding: 20px;
      background-color: #181E22;
  }
    .people-content-title{
        font-size: 14px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 14px;

    }
  .people-content-title2{
      padding-top: 15px;

  }
  .ticket_reservation {
      width: 100%;
      border-bottom: #2A446B 1px solid;
  }
  .people-content-item:last-child .ticket_reservation{
      border-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/ScenicDateData.vue